import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Grid } from '@material-ui/core';
import clsx from 'clsx';
import $ from 'jquery';
import { ReactSVG } from 'react-svg';
import { Icons } from '@/assets';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { setUserSettings, SaveApiResMessage } from '@/actions';
import SubmitButton from '@/ctComponents/submitButton';
import CloseButton from '@/ctComponents/closeButton';

export default ({
  noTitleAndIcon = false,
  title,
  DATA = [],
  options = {},
  setOptions,
  children,
  tableTheadTitle,
  EmptiesTableTheadTitle,
  ExportsTableTheadTitle,
  setTableType,
  tableType,
  toggled,
  mainToggleButtonRef,
}) => {
  const cls = styles();
  const [loading, setLoading] = React.useState(false);
  const [SubmitLoading, setSubmitLoading] = React.useState(false);
  const [ResetLoading, setResetLoading] = React.useState(false);
  const [optionsPosition, setOptionsPosition] = React.useState({});
  const optionsRef = useRef(null);
  const toggleButtonRef = useRef(null);
  const mainScroll = document.getElementsByTagName('main')[0];

  const handleClickOutside = useCallback(
    (event) => {
      // Only close if clicking outside the options card AND not on toggle buttons
      const isClickInsideOptions = optionsRef?.current?.contains(event.target);
      const isClickOnInternalToggle = toggleButtonRef?.current?.contains(
        event.target
      );
      const isClickOnMainToggle = mainToggleButtonRef?.current?.contains(
        event.target
      );

      // Only close if clicking truly outside the options container
      if (
        optionsRef?.current &&
        !isClickInsideOptions &&
        !isClickOnInternalToggle &&
        !isClickOnMainToggle
      ) {
        setOptions((prevOptions) => ({ ...prevOptions, open: false }));
      }
    },
    [optionsRef, toggleButtonRef, mainToggleButtonRef, setOptions]
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  // Scroll-based closing functionality
  useEffect(() => {
    const handleScroll = () => {
      const optionsRefRect = optionsRef.current.getBoundingClientRect();

      if (
        options.open &&
        mainScroll &&
        optionsRefRect.top < mainScroll.clientHeight
      ) {
        // Close when scroll is less than 100px
        setOptions((prevOptions) => ({ ...prevOptions, open: false }));
      }
    };

    if (options.open && mainScroll) {
      mainScroll.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (mainScroll) {
        mainScroll.removeEventListener('scroll', handleScroll);
      }
    };
  }, [options.open, setOptions, mainScroll]);

  const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 35,
      height: 18,
      padding: 0,
      overflow: 'visible',
      margin: theme.spacing(0.8),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 16,
      height: 16,
    },
    track: {
      borderRadius: 26,
      // border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: '#d5d5d5',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
  });

  const saveUserSettings = (data) => {
    if (!changedList || changedList.length === 0) {
      const req = {
        key: tableType,
        data: null,
      };

      setUserSettings(req)
        .then((res) => {
          window.location.reload();
        })
        .catch((err) => {
          console.log('posterr', err);
          SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
          setLoading(false);
        });

      return; // Exit the function if there are no changes
    }

    // Check if changedList is empty or unchanged
    if (!changedList || changedList.length === 0) {
      SaveApiResMessage({
        title: 'Info',
        message: 'No Changes...',
        mode: 'info',
      });
      setLoading(false);

      return; // Exit the function if there are no changes
    }

    const req = {
      key: tableType,
      data: changedList,
    };

    setUserSettings(req)
      .then((res) => {
        window.location.reload();
      })
      .catch((err) => {
        console.log('posterr', err);
        SaveApiResMessage({ title: 'Error', message: err, mode: 'warning' });
        setLoading(false);
      });
  };
  const [items, setItems] = useState([]);
  const [changedList, setChangedList] = useState([...(items ?? [])]);
  const [draggedItem, setDraggedItem] = useState(null);

  React.useEffect(() => {
    if (options.open) $('.options-card').slideDown();
    else $('.options-card').slideUp();
  }, [options.open]);

  // Calculate position relative to mainToggleButtonRef
  React.useEffect(() => {
    if (options.open && mainToggleButtonRef?.current) {
      const buttonRect = mainToggleButtonRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const optionsWidth = 305; // Width from styles

      // Calculate position
      let right = viewportWidth - buttonRect.right;
      let top = buttonRect.bottom + 5; // 5px gap below button

      // Ensure options don't go off screen
      if (right < 10) {
        right = 10; // Minimum margin from right edge
      }
      if (right + optionsWidth > viewportWidth) {
        right = viewportWidth - optionsWidth - 10;
      }

      // Check if there's enough space below, if not position above
      const viewportHeight = window.innerHeight;
      if (top + 450 > viewportHeight) {
        // 450 is height from styles
        top = buttonRect.top - 450 - 5; // Position above button
      }

      setOptionsPosition({
        right: `${right}px`,
        top: `${top}px`,
        position: 'absolute',
      });
    }
  }, [options.open, mainToggleButtonRef]);

  const setupItems = useCallback(
    (tableType) => {
      tableType === 'streetTurnEmptiesTable'
        ? setItems(EmptiesTableTheadTitle)
        : tableType === 'streetTurnExportsTable'
        ? setItems(ExportsTableTheadTitle)
        : setItems(tableTheadTitle);
    },
    [EmptiesTableTheadTitle, ExportsTableTheadTitle, tableTheadTitle]
  );

  const Toggle = (tableType) => {
    setupItems(tableType);
    if (!noTitleAndIcon) {
      setOptions({ ...options, open: !options.open });
    }
  };

  useEffect(() => {
    if (noTitleAndIcon) setupItems(tableType);
  }, [tableType, toggled, tableTheadTitle, noTitleAndIcon, setupItems]);

  const handleDragStart = (index) => {
    setDraggedItem(index);
  };

  const handleDragOver = (index) => {
    if (draggedItem === index) return;

    const newItems = [...items];
    const item = newItems[draggedItem];
    newItems.splice(draggedItem, 1);
    newItems.splice(index, 0, item);

    setDraggedItem(index);
    setItems(newItems);
    setChangedList(newItems);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  const toggleShow = (index) => {
    const newItems = items?.map((item, i) =>
      i === index ? { ...item, show: !item.show } : item
    );
    setItems(newItems);
    setChangedList(newItems);
  };

  return (
    <div className={cls.filterContainer}>
      {!noTitleAndIcon && (
        <div className={cls.headerBar}>
          <span className={cls.title}>{title}</span>

          <div className={cls.rocw3}>
            {children}
            <div
              ref={toggleButtonRef}
              className={cls.filterRow}
              onClick={() => Toggle(tableType)}>
              <span className={cls.title}></span>
              <ReactSVG src={Icons.options} className={cls.filter} />
            </div>
          </div>
        </div>
      )}
      <div
        ref={optionsRef}
        className={clsx(cls.card, 'options-card')}
        style={{
          display: 'none',
          ...optionsPosition,
        }}
        onClick={(ev) => ev.stopPropagation()}>
        <Grid className={cls.optionsBody} container spacing={2}>
          <p className={cls.cardTitle}>Configure Columns</p>
          <p className={cls.itemsTopTitle}>Shown attribute</p>
          <span className={cls.listSpan}>
            {(items ?? [])?.map((header, index) => (
              <span
                key={index}
                draggable
                onDragStart={() => handleDragStart(index)}
                onDragOver={() => handleDragOver(index)}
                onDragEnd={handleDragEnd}
                onClick={(ev) => ev.stopPropagation()}
                className={cls.actionsSpan}>
                <span className={cls.dragdropIconTitle}>
                  <ReactSVG src={Icons.dragdrop} className={cls.dragdropIcon} />
                  {header?.label}
                </span>
                <IOSSwitch
                  checked={header?.show}
                  onChange={(ev) => {
                    ev.stopPropagation();
                    toggleShow(index);
                  }}
                  onClick={(ev) => ev.stopPropagation()}
                  name="checkedShow"
                />
              </span>
            ))}
          </span>
        </Grid>

        <div className={cls.row2}>
          <span className={cls.btnsSpan}>
            <CloseButton
              width={'130px'}
              color="#131517"
              loading={ResetLoading}
              onClick={() => {
                setResetLoading(true);
                saveUserSettings('null');
              }}
              text="Restore Default"
            />
            <SubmitButton
              width={'130px'}
              loading={SubmitLoading}
              onClick={() => {
                setSubmitLoading(true);
                saveUserSettings();
              }}
              text="Save"
            />
          </span>
        </div>
      </div>
    </div>
  );
};
